import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "antd/dist/antd.css";
import "bootstrap/dist/css/bootstrap.css";
import "assets/css/style.css";
import "assets/scss/paper-dashboard.scss?v=1.3.0";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// Ant Design için yerel dili kullanma
import { ConfigProvider } from "antd";
import trTR from "antd/lib/locale/tr_TR";
import enEN from "antd/lib/locale/en_US";
import { Provider } from "react-redux";
import store from "./redux/store";
import LoadingSpinner from "views/components/loadingSpinner/LoadingSpinner";
import { I18nextProvider } from "react-i18next";
import "./i18n";
const App = React.lazy(() => import("./App"));
const lang = localStorage.getItem("i18nextLng");

ReactDOM.render(
  <Provider store={store}>
    <ConfigProvider locale={lang === "tr" ? trTR : enEN}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <Suspense fallback={<LoadingSpinner />}>
          <App />
        </Suspense>
      </BrowserRouter>
    </ConfigProvider>
  </Provider>,
  document.getElementById("root")
);
